import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';

interface Props {
  label: string;
  planIds: string[];
  isLoading?: boolean;
  isPrint?: boolean;
}

export const HeaderRow = ({ label, planIds, isLoading, isPrint }: Props) => {
  return (
    <Box as="tr" bg="neutral.100" css="page-break-inside: avoid; page-break-after: avoid">
      {times(planIds.length + 1).map(index => (
        <Box key={index} as="td" px="16" py="8">
          <Text height={16} variant="smallCaps">
            {isLoading || index !== 0 ? (
              isPrint ? (
                <Text css="font-size: 1px;" color="neutral.100">
                  Empty Cell
                </Text>
              ) : (
                ''
              )
            ) : (
              label
            )}
          </Text>
        </Box>
      ))}
    </Box>
  );
};
